import LibraryOutlineIcon from 'assets/Icons/LibraryOutlineIcon';
import ReceiptItem from 'assets/Icons/receipt-item';
import { useRouter } from 'next/router';
import React, { FC } from 'react';

interface Props {
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}
const HorizontalMenu: FC<Props> = ({ setShowDropDown, onClose }) => {
  const router = useRouter();
  const handleMyOrdersClick = () => {
    setShowDropDown(false);
    onClose();
    router.push('/my-orders/');
  };

  return (
    <div className='flex gap-1 px-5'>
      <button
        onClick={handleMyOrdersClick}
        className='bg-black rounded-[10px] border border-grayZl-900  p-2.5 flex flex-col gap-3 flex-1 items-start'
      >
        <ReceiptItem width={20} height={20} className='text-[#9F9EA6]' />
        <p className='text-xs/5 text-white font-medium'>My Orders</p>
      </button>

      <button
        onClick={() => {
          if (typeof window !== 'undefined') {
            const url = 'https://forms.gle/8sfLvPENJhUkQzna6';
            window.open(url, '_blank');
          }
          setShowDropDown(false);
        }}
        className='bg-black rounded-[10px] border border-grayZl-900  p-2.5 flex flex-col gap-3 flex-1 items-start'
      >
        <LibraryOutlineIcon width={20} height={20} className='text-[#9F9EA6]' />
        <p className='text-xs/5 text-white font-medium'>Invest In Us</p>
      </button>
    </div>
  );
};

export default HorizontalMenu;
